export default __webpack_public_path__ + "static/media/autozone_logo.b7550dae.png";